import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import moment from "moment";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import convertToExcel from "../../../components/ExportToExcel";

const RateCatalogList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getSalesRate } = useHttp();

  const FillDetail = () => {
    getSalesRate(
      {
        url: `/api/goodsIssuesalesrate/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getSalesRate]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { sendRequest: deleteRateCard } = useHttp();

  const handleDelete = (e, Id) => {
    const salesRateId = Id || 0;

    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Sales Rate detail?",
      onOk() {
        try {
          deleteRateCard(
            {
              url: `/api/goodsIssuesalesrate/?salesRateId=${salesRateId}&orgId=${localStorage.getItem(
                "orgId"
              )}`,
              method: "DELETE",
            },
            (data) => {
              toast.success(data.message);
              // console.log(data);
              FillDetail();
            },
            (error) => {
              console.log(error);

              toast.error(error.message);
            }
          );
        } catch (error) {
          console.error("Error:", error);
        }
      },
      onCancel() {},
    });
  };

  const fieldsToExport = [
    "salesPriceDate",
    "productTypeName",
    "productSubTypeName",
    "productName",
    "itemId",
    "unitAbbreviation",
    "salesRate",
    "qtyPerHa",
  ];

  const customHeaders = [
    "Date",
    "Product Item Type",
    "Product Item Subtype",
    "Product Name ",
    "Product No",
    "Unit",
    "Price Per Unit",
    "Quantity Per Hector",
  ];

  const handleExportExcel = () => {
    const filename = "SalesRateCardReport.xlsx";
    //console.log(fieldsToExport,customHeaders);

    const transformedData =
      data &&
      data.map((item) => ({
        ...item,

        salesPriceDate: moment(item.salesPriceDate).format("DD/MM/YYYY"),
      }));
    console.log(transformedData);

    convertToExcel(transformedData, fieldsToExport, filename, customHeaders);
  };

  const handleSearch = (e) => {
    var filtertext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.productTypeName.toLowerCase().includes(filtertext) ||
        item.productSubTypeName.toLowerCase().includes(filtertext) ||
        item.productName.toLowerCase().includes(filtertext)||
        item.itemId.toLowerCase().includes(filtertext)||
        item.unitAbbreviation.toLowerCase().includes(filtertext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;RateCatalog Detail{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Rate Catalog
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row text-right">
                      <div className="col-12">
                        <div className="">
                          <button
                            type="button"
                            className="btn btn-sm btn-warning"
                            onClick={handleExportExcel}
                          >
                            <i className="fas fa-file-excel"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Product Item Type </th>
                            <th>Product Item Subtype </th>
                            <th>Product Name </th>
                            <th>Product No </th>
                            <th>Unit </th>

                            <th>Price Per Unit</th>
                            <th>Quantity Per Hector</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>
                                  {moment(x.salesPriceDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </td>

                                <td>{x.productTypeName}</td>
                                <td>{x.productSubTypeName}</td>
                                <td>{x.productName}</td>
                                <td>{x.itemId}</td>
                                <td>{x.unitAbbreviation}</td>
                                <td>{x.salesRate}</td>
                                <td>{x.qtyPerHa}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={(e) =>
                                      handleDelete(e, x.salesRateId)
                                    }
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default RateCatalogList;
